<div class="horizontal-crawler-container">
	<div class="horizontal-crawler">
		<div class="logo-row">
			@for (item of itemsList; track $index) {
			<img [src]="item?.image" alt="" height="90%" />
			}
		</div>

		<div aria-hidden="true" class="logo-row">
			@for (item of itemsList; track $index) {
        <img [src]="item?.image" alt="" height="90%" />
        }
		</div>
	</div>


  <div class="horizontal-crawler reverse-animation">
		<div class="logo-row">
			@for (item of itemsList; track $index) {
			<img [src]="item?.image" alt="" height="90%" />
			}
		</div>

		<div aria-hidden="true" class="logo-row">
			@for (item of itemsList; track $index) {
        <img [src]="item?.image" alt="" height="90%" />
        }
		</div>
	</div>
</div>
